import { render, staticRenderFns } from "./NonDeliverable.vue?vue&type=template&id=c2630bca&scoped=true&"
import script from "./NonDeliverable.vue?vue&type=script&lang=js&"
export * from "./NonDeliverable.vue?vue&type=script&lang=js&"
import style0 from "./NonDeliverable.vue?vue&type=style&index=0&id=c2630bca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2630bca",
  null
  
)

export default component.exports